import styled from 'styled-components';

import { basicBodyTextStyle, basicSmallTextStyle, fonts } from '@dreryk/react-components';

export const StyledPatientFieldItemName = styled.div`
   ${basicBodyTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;

StyledPatientFieldItemName.displayName = 'StyledPatientFieldItemName';

export const StyledPatientFieldItemDetails = styled.div`
   ${basicSmallTextStyle};
   color: ${(props) => props.theme.border};
`;

StyledPatientFieldItemDetails.displayName = 'StyledPatientFieldItemDetails';
